import { render, staticRenderFns } from "./SelectSoleProprietorship.vue?vue&type=template&id=997941fa&scoped=true"
import script from "./SelectSoleProprietorship.vue?vue&type=script&lang=js"
export * from "./SelectSoleProprietorship.vue?vue&type=script&lang=js"
import style0 from "./SelectSoleProprietorship.vue?vue&type=style&index=0&id=997941fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997941fa",
  null
  
)

export default component.exports